/**
 * Builds a stable key for the city properties fetch.
 * Map viewport params (neighborhood, lat, lng, zoom) must not be part of this key,
 * otherwise pan/zoom would remount the search page as a skeleton.
 */
export function buildSearchFetchKey(
  city: string | null | undefined,
  uf: string | null | undefined,
  apiParamsKey: string
): string {
  return `${city ?? ""}|${uf ?? ""}|${apiParamsKey}`;
}
